<!--  -->
<template>
  <div class="sp_view">
    <!-- <div class="tabselecr_box">
      <div>
        <el-input v-model="query.keywords" clearable style="width:400px;margin-right:10px" placeholder="请输入企业id/自有员工编号/员工ID/员工姓名" />
        <el-button type="primary" style="margin:0px 10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button>
      </div>
    </div> -->
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
      max-height="500"
    >
      <!-- <el-table-column
        prop="id"
        label="id"
        align="center"
        width="50"
      /> -->
      <el-table-column
        prop="temporary_push_bind_no"
        label="绑定编号记录"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          {{ scope.row.temporary_push_bind_no }}
        </template>
      </el-table-column>
      <el-table-column
        prop="msg_id"
        label="官方接口返回id"
        align="center"
        width="300"
      />
      <el-table-column
        prop="send_count"
        label="发送人数"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.send_count }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="send_status_text"
        label="发送状态"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <div class="namebox">
            <i v-if="scope.row.send_status === 2" class="el-icon-success" style="color:#67c23a" />
            <i v-if="scope.row.send_status === 0" class="el-icon-error" style="color:#f56c6c" />
            {{ scope.row.send_status_text }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_time_text"
        label="创建时间"
        align="center"
        width="200"
      />
      <el-table-column
        prop="status_text"
        label="状态"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <div>
            <i v-if="scope.row.status === 1" class="el-icon-success" style="color:#67c23a" />
            <i v-if="scope.row.status === 2" class="el-icon-error" style="color:#f56c6c" />
            {{ scope.row.status_text }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
        width="150"
      />
      <el-table-column
        prop="remark"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button v-if="scope.row.msg_id!=''" type="primary" size="mini" @click="sendlist(scope.row)">推送记录</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="详情"
      :visible.sync="dialogsendinfo"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      width="70%"
    >
      <sendinfo ref="sendinfoview" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { temporaryPushpushRecord } from '@/api/officialaccount.js'
import sendinfo from '../../enterprisemilist/components/sendinfo.vue'
export default {
  name: 'Enterprisestaff',
  components: { PaginationRight, sendinfo },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        page_size: 10,
        keywords: null,
        temporary_push_bind_no: null
      },
      dialogsendinfo: false
    }
  },
  created() {
    // this.list()
  },
  mounted() {

  },
  methods: {
    async list() {
      this.loading = true
      const data = await temporaryPushpushRecord(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.list()
    },
    send(temporary_push_bind_no) {
      this.query.temporary_push_bind_no = temporary_push_bind_no
      this.list()
    },
    sendlist(item) {
      this.dialogsendinfo = true
      this.$nextTick(() => {
        this.$refs.sendinfoview.send(item)
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sp_view{
  padding: 30px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.namebox{
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
  }
</style>
